module.exports = __webpack_public_path__ + "img/poker.1d222f56.png";